import { apiGet } from "./client";

const CACHE_TTL_MS = 60_000;
const discoverCache = new Map();

function buildCacheKey(params = {}) {
  return JSON.stringify(params);
}

export function invalidateDiscoverCache() {
  discoverCache.clear();
}

export async function fetchDiscoverProfiles({
  lat,
  lng,
  radiusKm = 50,
  page = 1,
  limit = 24,
  categories = [],
  services = [],
  cities = [],
  country = null,
  signal = null,
} = {}) {
  const params = {
    lat,
    lng,
    radiusKm,
    page,
    limit,
  };

  if (categories.length) params.categories = categories.join(",");
  if (services.length) params.services = services.join(",");
  if (cities.length) params.cities = cities.join(",");
  if (country) params.country = country;

  const cacheKey = buildCacheKey(params);
  const cached = discoverCache.get(cacheKey);
  if (cached && Date.now() - cached.at < CACHE_TTL_MS) {
    return cached.data;
  }

  const data = await apiGet("/discover/profiles", {
    params,
    signal,
  });

  discoverCache.set(cacheKey, { at: Date.now(), data });
  return data;
}
